export default __webpack_public_path__ + "static/sketch-3.0.1-thumbs-b318e7f4e9c0c9758ae3f4f8d654e788.png";